// extracted by mini-css-extract-plugin
export default {"regContainer":"register_regContainer__nuCah","regH2":"register_regH2__Ne9-t","regMessage":"register_regMessage__cC114"};